import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiURL: string = '';
  private apiURLNew: string = '';
  private apiKey: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.apiURLNew = this.appConfig.getEnvironmentNew().url;
    this.apiKey = this.appConfig.getApiKey();
    this.env = this.appConfig.getEnvironmentNew();
  }

  registerUser(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/Account/Register', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  registerTechnicians(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/Account/Register/Technicians', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  changeMyPassword(
    oldPassword: string,
    password: string,
    confirmPassword: string,
  ) {
    let data = {
      OldPassword: oldPassword,
      NewPassword: password,
      ConfirmPassword: confirmPassword,
    };
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/Account/ChangePassword', data, requestOptions)
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  checkIfUserAvailable(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/Account/IsUserAvailable', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  connectUser() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/Account/ConnectUserToTechnician', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getUserDetail(username: string) {
    let body = '"' + username + '"';
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .post(this.apiURL + '/Account/UserDetail', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getConnectedBikeShops() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/Account/UsersConnectedPartners', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getUserRolesInsurance(ID: string) {
    let requestOptions = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + '/v4/Insurance/' + ID + '/Profiles?code=' + this.env.key,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postAskApproval(partnerID, cyclistID, title, message, link, jobcardID, sendToThirdPartyOnly) {
    const headers = this.helpersService.getNewApiHeaders();
    const data = {
      PartnerID: partnerID,
      UserID: cyclistID,
      CreatedBy: partnerID,
      Title: title,
      Message: message,
      JobURLLink: this.env.portalUrl + link,
      JobcardNo: jobcardID,
      SendToThirdPartyOnly: sendToThirdPartyOnly
    };
    return this.http
      .post(
        this.env.url +
        '/v3/Athlete/' +
        cyclistID +
        '/RequestApproval?code=' +
        this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          this.errorHandler.showError(res,
            "Failed to send quote for approval");
          return throwError(res.json());
        }),
      );
  }

  postAskApprovalV2(partnerID, cyclistID, jobcardID, sendToThirdPartyOnly) {
    const headers = this.helpersService.getNewApiHeaders();
    const data = {
      PartnerID: partnerID,
      UserID: cyclistID,
      CreatedBy: partnerID,
      JobcardNo: jobcardID,
      SendToThirdPartyOnly: sendToThirdPartyOnly
    };
    return this.http
      .post(
        this.env.url +
        '/v3/Athlete/' +
        cyclistID +
        '/RequestApproval?code=' +
        this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          this.errorHandler.showError(res,
            "Failed to send quote for approval");
          return throwError(res.json());
        }),
      );
  }

  createCustomer(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(this.env.url + '/store/customers?code=' + this.env.key, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        })
      );
  }

  createCustomerV2(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(this.env.url + '/V2/store/customers?code=' + this.env.key, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        })
      );
  }

  createCustomerV3(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(this.env.url + '/V3/store/customers?code=' + this.env.key, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        })
      );
  }

  updateCustomer(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(this.env.url + '/store/customers?code=' + this.env.key, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        })
      );
  }

  deleteCustomer(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(this.env.url + `/store/customers/delete?code=` + this.env.key, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        })
      );
  }
}
